// dashboard/frontend/src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { 
    Container, 
    Typography, 
    Grid, 
    Card, 
    CardContent,
    List,
    ListItem,
    ListItemText,
    Divider,
    Box
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import { format } from 'date-fns';
// CHANGED: hot contacts engagement panel
import HotContacts from '../components/Notifications/HotContacts';

function Dashboard() {
    const { user } = useAuth();
    const [stats, setStats] = useState({
        activeCampaigns: 0,
        scheduledCampaigns: 0,
        emailsSentToday: 0,
        activeAccounts: 0,
        availableSendsToday: 0,
        upcomingEmails: 0,
        scheduledStats: {
            totalScheduled: 0,
            nextScheduled: null
        }
    });

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                const response = await api.get('/dashboard/stats/');
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }
        };

        fetchDashboardData();
        const interval = setInterval(fetchDashboardData, 60000); // Refresh every minute
        return () => clearInterval(interval);
    }, []);

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Welcome, {user?.first_name || user?.username}
            </Typography>
            
            <Grid container spacing={3}>
                {/* Active Campaigns */}
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Active Campaigns
                            </Typography>
                            <Typography variant="h4">
                                {stats.activeCampaigns}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Scheduled Campaigns */}
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Scheduled Campaigns
                            </Typography>
                            <Typography variant="h4">
                                {stats.scheduledCampaigns}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {stats.scheduledStats.totalScheduled} emails scheduled
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Today's Activity */}
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Today's Activity
                            </Typography>
                            <Typography>
                                Sent: {stats.emailsSentToday}
                            </Typography>
                            <Typography>
                                Available: {stats.availableSendsToday}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Upcoming Emails */}
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Next 24 Hours
                            </Typography>
                            <Typography>
                                {stats.upcomingEmails} emails scheduled to send
                            </Typography>
                            {stats.scheduledStats.nextScheduled && (
                                <Typography variant="body2" color="textSecondary">
                                    Next email scheduled for: {
                                        format(
                                            new Date(stats.scheduledStats.nextScheduled.scheduled_for),
                                            'MMM d, yyyy h:mm a'
                                        )
                                    }
                                </Typography>
                            )}
                        </CardContent>
                    </Card>
                </Grid>

                {/* CHANGED: Hot Contacts engagement panel */}
                <Grid item xs={12}>
                    <HotContacts />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;